import { QueryClient } from '@tanstack/react-query';

/**
 * Single QueryClient for the app. Kiosk network conditions can be flaky,
 * so retries are conservative but non-zero; mutations (uploads, payments)
 * never auto-retry since re-submitting a payment or upload silently is
 * unsafe — the calling hook decides whether to prompt the user to retry.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
